import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  CardActions,
  Typography,
  Button,
  Box,
  Badge,
  Divider,
  Grid,
  useMediaQuery,
  Chip,
  Stack,
  Snackbar,
  CircularProgress,
} from "@mui/material";
import burgerImg from "../../assets/menuBurgerImg.png";
import { useNavigate } from "react-router-dom";
import AddToCart from "./AddToCart";
import { useDispatch, useSelector } from "react-redux";
import { useTheme } from "@emotion/react";
import {
  IMG_BASE_URL,
  format_Number,
  getHeight,
  validateSupplements,
} from "../../utils/utils";
import {
  UpdateAddToCartProducts,
  setItemCount,
  setRecommendedProductError,
  setSelectedProduct,
  setSelectedRecommendedProduct,
  setSupplementError,
  setSupplementInfo,
  setTotalProductCount,
  setWebshopProductData,
  setWebshopProductInfo,
  setWebshopRelatedProductsInfo,
} from "../../store/slice/Webshop.slice";
import dayjs from "dayjs";
import { FetchWebshopProductsInfo } from "../../api/Webshop.service";

const ExpandableText = ({ text }) => {
  const [expanded, setExpanded] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);

  const { languageWords } = useSelector((store) => store?.Webshop);
  const handleToggle = () => {
    setExpanded((prev) => !prev);
  };

  return (
    <Box>
      <Typography
        variant="body2"
        color="textSecondary"
        mb={2}
        sx={{
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          textOverflow: "ellipsis",
          WebkitLineClamp: expanded ? "none" : 3,
          cursor: "pointer",
        }}
        onClick={handleToggle}
      >
        {text}
      </Typography>
      {expanded && (
        <Typography
          variant="body2"
          color="grey"
          sx={{ cursor: "pointer" }}
          onClick={handleToggle}
        >
          {languageWords?.Showless}
        </Typography>
      )}
    </Box>
  );
};
export const RibbonTag = ({ data }) => {
  const { languageWords } = useSelector((store) => store.Webshop);
  return (
    <Box
      sx={{
        position: "absolute",
        top: 50,
        right: -30,
        backgroundColor: "red",
        color: "white",
        padding: "5px 50px",
        fontWeight: "bold",
        transform: "rotate(35deg)",
        transformOrigin: "top right",
        zIndex: 1,
        fontSize: "12px",
        borderRadius: "4px",
      }}
    >
      {data}
    </Box>
  );
};

export const LabelText = ({ label, color, bgColor, top, left }) => {
  return (
    <Box
      sx={{
        position: "absolute",
        top: top,
        left: left,
        width: 130,
        background: bgColor || "linear-gradient(135deg, #ff5722, #ff8a50)",
        textAlign: "center",
        color: color || "red",
        fontWeight: "bold",
        fontSize: 14,
        py: 0.6,
        px: 2.5,
        zIndex: 10,
        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.3)",
        borderRadius: "8px",
        textTransform: "uppercase",
        letterSpacing: 1,
      }}
    >
      {label}
    </Box>
  );
};

const MenuListCardsComponent = ({ data = [], recommededProducts = false }) => {
  const { css } = useSelector((store) => store?.widgetSettings);
  const card = css?.find(
    (item) => item?.cssTabFieldsGroupName === "ProductCard"
  )?.fields;
  const navigate = useNavigate();
  const [buttonLoader, setButtonLoader] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);
  const [loadingProductId, setLoadingProductId] = useState(null);
  const [imgError, setImgError] = useState(false);
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();
  const {
    shopType,
    webShopProductInfo,
    itemCount,
    supplementsInfo,
    webshopSettings,
    totalProductsCount,
    addToCartProducts,
    defaultLanguage,
    languageWords,
    selectedProduct,
    supplementError,
    selectedRecommendedProduct,
    CurrencyData,
    webShopMenuPosition,
  } = useSelector((store) => store?.Webshop);
  const { key, resType } = useSelector((store) => store?.widgetSettings);
  const theme = useTheme();
  let specialPrice;
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [selectedSupplements, setSelectedSupplements] =
    useState(supplementsInfo);
  const [isOpenAlert, setIsAlert] = useState(false);
  const currentDate = dayjs();
  const [itemCounts, setItemCounts] = useState(itemCount);
  const [action, setAction] = useState("");
  const [openSnackBar, setOpenSnackBar] = React.useState(false);

  const handleClickOpenSnackBar = () => {
    setOpenSnackBar(true);
  };
  const handleClickCloseSnackBar = () => {
    setOpenSnackBar(false);
  };

  React.useEffect(() => {
    const initialCounts = data.reduce((acc, item) => {
      acc[item?.idproduct] = 1;
      return acc;
    }, {});
    setItemCounts((prev) => ({ ...prev, ...initialCounts }));
  }, [data]);

  const getProductsInfo = async (key, defaultLanguage, item) => {
    setLoader(true);
    try {
      const productDataDetails = await FetchWebshopProductsInfo(
        key,
        defaultLanguage,
        item?.idproduct
      );

      if (!productDataDetails) {
        console.error("Error fetching product list:", productDataDetails);
      } else {
        dispatch(setWebshopProductInfo({ data: productDataDetails?.data }));
      }
    } catch (error) {
      console.error("Error fetching product list:", error);
    } finally {
      setLoader(false);
    }
  };

  const handleClickOpen = async (item, event) => {
    if (loadingProductId) return; // prevent double click
    dispatch(setWebshopRelatedProductsInfo([]));
    setLoadingProductId(item.idproduct);
    setButtonLoader(true); // show loader on the button

    try {
      // Check for recommended product logic
      if (recommededProducts) {
        if (
          webShopProductInfo?.data?.relatedProductOnlyOneSelected &&
          addToCartProducts.length > 0
        ) {
          let count = 0;
          addToCartProducts.forEach((product) => {
            if (product?.recommededProducts) count++;
          });

          if (count >= 1) {
            handleClickOpenSnackBar();
            dispatch(
              setRecommendedProductError(
                "Only one Recommended Product Selected"
              )
            );
            setButtonLoader(false);
            return;
          }
        }

        // Select recommended product
        if (
          !addToCartProducts?.find(
            (product) => product.idproduct === item.idproduct
          )
        ) {
          dispatch(
            setSelectedRecommendedProduct({
              ...item,
              prodCount: itemCount[item?.idproduct],
              recommededProducts: true,
            })
          );
        }
      }

      // Fetch product info and wait for completion
      await getProductsInfo(key, defaultLanguage, item);

      // Update cart after fetch
      const existingProduct = addToCartProducts?.find(
        (prod) => prod.idproduct == item.idproduct
      );
      if (!existingProduct) {
        dispatch(
          UpdateAddToCartProducts({
            ...item,
            prodCount: itemCount[item?.idproduct],
            recommededProducts: recommededProducts || false,
          })
        );
      }

      dispatch(setSelectedProduct(item));

      // Navigate only after product info loaded
      navigate(
        webShopMenuPosition !== "null"
          ? recommededProducts
            ? "/webshopMenuItem/cartdetail"
            : "/webshopMenuItem/addtocart"
          : recommededProducts
            ? "/cartdetail"
            : "/addtocart",
        { state: recommededProducts }
      );
    } catch (error) {
      console.error("Error handling click:", error);
    } finally {
      setButtonLoader(false); // hide loader
    }
  };

  const handleBadgeClick = (productId, supplementItem, detailsKey) => {
    setSelectedSupplements((prev) => {
      const productIndex = prev.findIndex(
        (product) => product.idproduct === productId
      );

      if (productIndex > -1) {
        const existingProduct = prev[productIndex];
        const existingSupplements = existingProduct.supplements || [];
        const isAlreadyAdded = existingSupplements.some(
          (item) =>
            item.idwebshopsupplementitem ===
            supplementItem.idwebshopsupplementitem &&
            item.detailsKey === detailsKey
        );

        if (isAlreadyAdded) {
          const updatedSupplements = existingSupplements.filter(
            (item) =>
              item.idwebshopsupplementitem !==
              supplementItem.idwebshopsupplementitem ||
              item.detailsKey !== detailsKey
          );
          if (updatedSupplements.length === 0) {
            return prev.filter((_, index) => index !== productIndex);
          }
          return prev.map((product, index) =>
            index === productIndex
              ? { ...product, supplements: updatedSupplements }
              : product
          );
        } else {
          return prev.map((product, index) =>
            index === productIndex
              ? {
                ...product,
                supplements: [
                  ...existingSupplements,
                  { ...supplementItem, detailsKey },
                ],
              }
              : product
          );
        }
      } else {
        return [
          ...prev,
          {
            idproduct: productId,
            supplements: [{ ...supplementItem, detailsKey }],
          },
        ];
      }
    });
  };
  useEffect(() => {
    const countedProductIds = new Set();
    const totalCountProducts = addToCartProducts
      .filter((prod) => {
        if (
          prod.idproduct &&
          Object.keys(itemCount).includes(prod.idproduct.toString()) &&
          !countedProductIds.has(prod.idproduct)
        ) {
          countedProductIds.add(prod.idproduct);
          return true;
        }
        return false;
      })
      .reduce((sum, prod) => sum + (itemCount[prod.idproduct] || 0), 0);
    dispatch(setTotalProductCount(totalCountProducts));
  }, [itemCount, addToCartProducts]);

  useEffect(() => {
    dispatch(setItemCount(itemCounts));
  }, [itemCounts]);

  useEffect(() => {
    if (selectedSupplements.length > 0)
      dispatch(setSupplementInfo([...selectedSupplements]));
  }, [selectedSupplements]);

  if (!Array.isArray(data)) {
    console.error("Invalid data prop: expected an array");
    return null;
  }

  const ProductPrice = (id, productPrice) => {
    let productTotal;
    const supplementInfo = supplementsInfo?.find(
      (item) => item?.idproduct == id
    );
    const supplementTotal =
      supplementInfo?.supplements?.reduce(
        (suppAcc, supplement) => suppAcc + (supplement?.price || 0),
        0
      ) || 0;
    if (itemCount[id] == 0) {
      productTotal = productPrice * 1 + supplementTotal;
    } else {
      productTotal = productPrice * (itemCount[id] || 0) + supplementTotal;
    }

    return format_Number(productTotal);
  };

  return (
    <>
      <Box mt={3} px={2} sx={{ position: "relative" }}>
        <Grid container spacing={2}>
          {data
            ?.filter((item) => {
              const isActive = item?.active;
              const isSoldOut =
                item?.stockactive &&
                (item.availablestock === 0 || item?.soldout);
              if (
                !webshopSettings?.showOutofStockItemsInWebshopWidget &&
                isSoldOut
              ) {
                return false;
              }

              return isActive;
            })
            ?.map((item) => {
              specialPrice = item?.specialPriceFields?.find((price) =>
                currentDate.isBetween(
                  dayjs(price.specialpricefrom, "DD-MM-YYYY"),
                  dayjs(price.specialpriceto, "DD-MM-YYYY"),
                  null,
                  "[]"
                )
              );
              const tags = Object?.keys(item)
                .filter((key) => key?.startsWith("tagText"))
                .map((key) => {
                  const index = key?.replace("tagText", "");
                  return {
                    text: item[key],
                    bgColor: item[`tagBackgroundColor${index}`] || "#007bff",
                    textColor: item[`tagColor${index}`] || "#fff",
                  };
                })
                .filter((tag) => tag.text);

              return (
                <Grid
                  key={item?.idproduct}
                  item
                  xs={12}
                  sm={12}
                  md={resType === "kiosk" ? 6 : 6}
                  lg={resType === "kiosk" ? 6 : 4}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Card
                    sx={{
                      width: isSmallScreen ? "100%" : "70%",
                      minWidth: "180px",
                      maxWidth: "400px",
                      borderRadius: 4,
                      backgroundColor: addToCartProducts?.find(
                        (prod) => prod?.idproduct == item?.idproduct
                      )
                        ? card?.productCardSelectBgClr
                        : card?.productCardBgClr,
                      opacity:
                        item?.stockactive &&
                          (item.availablestock == 0 || item?.soldout)
                          ? 0.7
                          : 1,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      boxShadow: "0 6px 18px rgba(0, 0, 0, 0.08)",
                      position: "relative",
                      p: 2,
                      transition: "all 0.3s ease",
                      "&:hover": {
                        transform: "translateY(-6px)",
                        boxShadow: "0 10px 25px rgba(0, 0, 0, 0.15)",
                      },
                    }}
                  >
                    {item?.stockactive &&
                      (item.availablestock == 0 || item?.soldout) && (
                        <RibbonTag data={languageWords?.SoldOut || "Soldout"} />
                      )}
                    {item?.labelName && (
                      <LabelText
                        label={item?.labelName}
                        color={item?.labelTextColor}
                        bgColor={item?.labelBackgroundColor}
                        top={20}
                        left={20}
                      />
                    )}

                    {item?.imagefilename && !imgError && (
                      <Box
                        sx={{
                          width: "100%",
                          height: "auto",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          mt: 1,
                          position: "relative",
                        }}
                      >
                        {item?.imagefilename && (
                          <img
                            src={`${IMG_BASE_URL}/upload/WebshopProduct${item.imagefilename.replace(
                              /\\/g,
                              "/"
                            )}`}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "contain", // ✅ shows full image, no cut
                              borderRadius: 7,
                            }}
                            alt="menu_item_img"
                            onError={(e) => {
                              e.target.style.display = "none";
                            }}
                          />
                        )}
                      </Box>
                    )}
                    <CardContent sx={{ flexGrow: 1 }}>
                      <Box
                        sx={{
                          display: "flex",
                          gap: 1,
                        }}
                      >
                        {item?.tag1Name && (
                          <Typography
                            sx={{
                              fontSize: isSmallScreen ? "10px" : "12px",
                              fontWeight: "bold",
                              padding: isSmallScreen ? "2px 6px" : "4px 8px",
                              borderRadius: "4px",
                              color: item?.tag1TextColor,
                              backgroundColor: item?.tag1BackgroundColor,
                              boxShadow: "0px 2px 5px rgba(0,0,0,0.2)",
                            }}
                          >
                            {item?.tag1Name}
                          </Typography>
                        )}
                        {item?.tag2Name && (
                          <Typography
                            sx={{
                              fontSize: isSmallScreen ? "10px" : "12px",
                              fontWeight: "bold",
                              padding: isSmallScreen ? "2px 6px" : "4px 8px",
                              borderRadius: "4px",
                              color: item?.tag2TextColor,
                              backgroundColor: item?.tag2BackgroundColor,
                              boxShadow: "0px 2px 5px rgba(0,0,0,0.2)",
                            }}
                          >
                            {item?.tag2Name}
                          </Typography>
                        )}
                        {item?.tag3Name && (
                          <Typography
                            sx={{
                              fontSize: isSmallScreen ? "10px" : "12px",
                              fontWeight: "bold",
                              padding: isSmallScreen ? "2px 6px" : "4px 8px",
                              borderRadius: "4px",
                              color: item?.tag3TextColor,
                              backgroundColor: item?.tag3BackgroundColor,
                              boxShadow: "0px 2px 5px rgba(0,0,0,0.2)",
                            }}
                          >
                            {item?.tag3Name}
                          </Typography>
                        )}
                      </Box>
                      <Box mb={1}>
                        {/* NAME + ORANGE PRICE (SAME LINE) */}
                        <Box
                          display="flex"
                          justifyContent="space-between"
                          alignItems="baseline"
                        >
                          <Typography
                            variant="subtitle1"
                            fontWeight="bold"
                            sx={{
                              lineHeight: 1.2,
                              color: addToCartProducts?.find(
                                (prod) => prod?.idproduct == item?.idproduct
                              )
                                ? card?.productCardSelectTitleClr
                                : card?.productCardTitleClr,
                            }}
                          >
                            {item?.displayname || item?.displayName}
                          </Typography>

                          <Typography
                            sx={{
                              fontSize: "16px",
                              fontWeight: 700,
                              color: addToCartProducts?.find(
                                (prod) => prod?.idproduct == item?.idproduct
                              )
                                ? card?.productSelectPriceClr
                                : card?.productPriceClr,
                              lineHeight: 1,
                              whiteSpace: "nowrap",
                            }}
                          >
                            {CurrencyData?.value?.currencySymbol}
                            {format_Number(
                              specialPrice?.specialprice || recommededProducts
                                ? item?.relatedproductprice
                                : item?.price
                            )}
                          </Typography>
                        </Box>

                        {/* STRIKE PRICE (BELOW ORANGE PRICE) */}
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            minHeight: 18, // 🔒 prevents jump
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: "14px",
                              color: "#9e9e9e",
                              textDecoration: "line-through",
                              visibility:
                                specialPrice?.specialprice > 0 &&
                                  item?.price > 0
                                  ? "visible"
                                  : "hidden",
                            }}
                          >
                            {CurrencyData?.value?.currencySymbol}
                            {format_Number(item?.price)}
                          </Typography>
                        </Box>
                      </Box>
                      {item?.info && <Typography
                        sx={{
                          color: addToCartProducts?.find(
                            (prod) => prod?.idproduct == item?.idproduct
                          )
                            ? card?.productSelectCardInfoClr
                            : card?.productCardInfoClr,
                          fontSize: "14px"
                        }}
                      >
                        {item?.info}
                      </Typography>}

                      {webshopSettings?.showThreeSupplements &&
                        recommededProducts && (
                          <Box
                            display="flex"
                            flexDirection="column"
                        //    gap={2}
                            flexWrap="wrap"
                           // sx={{ minHeight: "60px" }}
                          >
                            {[
                              "supplementProductsDetails1",
                              "supplementProductsDetails2",
                              "supplementProductsDetails3",
                            ].map((detailsKey, index) => (
                              <Box key={index}>
                                {item?.[detailsKey]?.map((type, idx) => (
                                  <Badge
                                    key={idx}
                                    variant="outlined"
                                    sx={{
                                      padding: "4px 8px",
                                      border: "1px solid",
                                      borderColor:
                                        detailsKey ===
                                          "supplementProductsDetails1"
                                          ? "#00DC1B"
                                          : detailsKey ===
                                            "supplementProductsDetails2"
                                            ? "#F3D120"
                                            : "#9600DC",
                                      color:
                                        detailsKey ===
                                          "supplementProductsDetails1"
                                          ? "#00DC1B"
                                          : detailsKey ===
                                            "supplementProductsDetails2"
                                            ? "#F3D120"
                                            : "#9600DC",
                                      borderRadius: "8px",
                                      m: 0.3,
                                      backgroundColor: supplementsInfo
                                        ?.find(
                                          (supplement) =>
                                            supplement?.idproduct ===
                                            item?.idproduct
                                        )
                                        ?.supplements?.some(
                                          (supp) =>
                                            supp?.idwebshopsupplementitem ===
                                            type?.idwebshopsupplementitem
                                        )
                                        ? "#F2F9FF"
                                        : "",
                                      mr: 1,
                                      cursor: "pointer",

                                      fontSize: "12px",
                                    }}
                                    onClick={() =>
                                      handleBadgeClick(
                                        item.idproduct,
                                        type,
                                        detailsKey
                                      )
                                    }
                                  >
                                    {type?.displayName}{" "}
                                    {type?.price > 0 ? (
                                      <small
                                        style={{
                                          marginLeft: "0.4rem",
                                          textAlign: "center",
                                          marginTop: "0.2rem",
                                        }}
                                      >
                                        {CurrencyData?.value?.currencySymbol}
                                        {format_Number(type?.price)}
                                      </small>
                                    ) : null}
                                  </Badge>
                                ))}
                              </Box>
                            ))}
                          </Box>
                        )}
                      {imgError && (
                        <Box
                          sx={{
                            left: "20px",
                            display: "flex",
                            gap: 1,
                          }}
                        >
                          {item?.tag1Name && (
                            <Typography
                              sx={{
                                fontSize: isSmallScreen ? "10px" : "12px",
                                fontWeight: "bold",
                                padding: isSmallScreen ? "2px 6px" : "4px 8px",
                                borderRadius: "4px",
                                color: "black",
                                backgroundColor: "grey",
                                boxShadow: "0px 2px 5px rgba(0,0,0,0.2)",
                              }}
                            >
                              {item?.tag1Name}
                            </Typography>
                          )}
                          {item?.tag2Name && (
                            <Typography
                              sx={{
                                fontSize: isSmallScreen ? "10px" : "12px",
                                fontWeight: "bold",
                                padding: isSmallScreen ? "2px 6px" : "4px 8px",
                                borderRadius: "4px",
                                color: "black",
                                backgroundColor: "grey",
                                boxShadow: "0px 2px 5px rgba(0,0,0,0.2)",
                              }}
                            >
                              {item?.tag2Name}
                            </Typography>
                          )}
                          {item?.tag3Name && (
                            <Typography
                              sx={{
                                fontSize: isSmallScreen ? "10px" : "12px",
                                fontWeight: "bold",
                                padding: isSmallScreen ? "2px 6px" : "4px 8px",
                                borderRadius: "4px",
                                color: "black",
                                backgroundColor: "grey",
                                boxShadow: "0px 2px 5px rgba(0,0,0,0.2)",
                              }}
                            >
                              {item?.tag3Name}
                            </Typography>
                          )}
                        </Box>
                      )}
                    </CardContent>
                    <Divider />
                    <CardActions>
                      <Button
                        fullWidth
                        variant="contained"
                        color="primary"
                        sx={{
                          backgroundColor: addToCartProducts?.find(
                            (prod) => prod?.idproduct == item?.idproduct
                          ) ? card?.productListbuttonSelectBgClr ?? "#fff" :
                            card?.productListbuttonBgClr ?? "#F37120",
                            color:addToCartProducts?.find(
                              (prod) => prod?.idproduct == item?.idproduct
                            ) ? card?.productListbuttonSelectTxtClr ?? "#F37120" : "#fff"
                        }}
                        onClick={(e) => handleClickOpen(item, e)}
                        disabled={
                          loadingProductId === item.idproduct ||
                          (item?.stockactive &&
                            (item.availablestock === 0 || item?.soldout))
                        }
                      >
                        {loadingProductId === item.idproduct ? (
                          <CircularProgress size={22} sx={{ color: "#fff" }} />
                        ) : (
                          languageWords?.AddToCart
                        )}
                      </Button>
                    </CardActions>
                  </Card>
                </Grid>
              );
            })}
        </Grid>
      </Box>
      <Snackbar
        open={openSnackBar}
        text={supplementError?.message}
        handleOpen={handleClickOpenSnackBar}
        handleClose={handleClickCloseSnackBar}
      />
    </>
  );
};

export default MenuListCardsComponent;
